export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/SellCar.32ab6397.svg","height":130,"width":300,"blurWidth":0,"blurHeight":0};